document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var pageParams = new URLSearchParams(window.location.search);
  var campaign = {};

  campaignKeys.forEach(function (key) {
    var incoming = pageParams.get(key);
    if (incoming) {
      campaign[key] = incoming.slice(0, 120);
      try { window.sessionStorage.setItem('vk_' + key, campaign[key]); } catch (error) {}
      return;
    }
    try { campaign[key] = window.sessionStorage.getItem('vk_' + key) || ''; } catch (error) { campaign[key] = ''; }
  });

  function campaignPayload() {
    return {
      traffic_source: campaign.utm_source && campaign.utm_source.toLowerCase() === 'instagram' ? 'instagram' : (campaign.utm_source || 'direct_or_unknown'),
      campaign: campaign.utm_campaign || ''
    };
  }

  function publish(eventName, payload) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    var result = window.Shopify.analytics.publish('vegas_kings:' + eventName, payload || {});
    if (result && typeof result.catch === 'function') result.catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var tracked = event.target.closest('[data-vk-event]');
    if (tracked) {
      var requestedEvent = tracked.getAttribute('data-vk-event');
      var eventMap = {
        access_cta: 'access_cta_clicked',
        record_cta: 'record_cta_clicked',
        package_view: 'package_link_clicked',
        monthly_inquiry_start: 'monthly_inquiry_started'
      };
      if (eventMap[requestedEvent]) {
        publish(eventMap[requestedEvent], Object.assign({
          location: tracked.getAttribute('data-vk-location') || '',
          package: tracked.getAttribute('data-vk-package') || ''
        }, campaignPayload()));
      }
    }

    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || !url.hash) return;
    var target = document.querySelector(url.hash);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    history.pushState(null, '', url.hash);
  });

  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    function closeNavigation() {
      navToggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      document.body.classList.remove('nav-open');
      var label = navToggle.querySelector('.sr-only');
      if (label) label.textContent = 'Open menu';
    }
    navToggle.addEventListener('click', function () {
      var isOpen = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('nav-open', !isOpen);
      var label = navToggle.querySelector('.sr-only');
      if (label) label.textContent = isOpen ? 'Open menu' : 'Close menu';
    });
    nav.addEventListener('click', function (event) {
      if (!event.target.closest('a')) return;
      closeNavigation();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || navToggle.getAttribute('aria-expanded') !== 'true') return;
      closeNavigation();
      navToggle.focus();
    });
    document.addEventListener('click', function (event) {
      if (navToggle.getAttribute('aria-expanded') !== 'true') return;
      if (nav.contains(event.target) || navToggle.contains(event.target)) return;
      closeNavigation();
    });
  }

  document.querySelectorAll('[data-access-selector]').forEach(function (selector) {
    var tabs = Array.prototype.slice.call(selector.querySelectorAll('[data-access-tab]'));
    var panels = Array.prototype.slice.call(selector.querySelectorAll('[data-access-panel]'));

    function activate(tab, setFocus, trackEvent) {
      var value = tab.getAttribute('data-access-tab');
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.setAttribute('tabindex', selected ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var isSelected = panel.getAttribute('data-access-panel') === value;
        panel.classList.toggle('is-active', isSelected);
        panel.hidden = !isSelected;
      });
      try { window.sessionStorage.setItem('vk_access_window', value); } catch (error) {}
      if (trackEvent) publish('access_window_selected', Object.assign({ window: value }, campaignPayload()));
      if (setFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab, false, true); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activate(tabs[nextIndex], true, true);
      });
    });

    var initialValue = pageParams.get('window');
    if (!initialValue) {
      try { initialValue = window.sessionStorage.getItem('vk_access_window'); } catch (error) {}
    }
    var initialTab = tabs.find(function (item) { return item.getAttribute('data-access-tab') === initialValue; }) || tabs[0];
    if (initialTab) activate(initialTab, false, false);
  });

  document.querySelectorAll('[data-preserve-campaign]').forEach(function (link) {
    if (!campaign.utm_source) return;
    var target = new URL(link.href, window.location.origin);
    if (target.origin !== window.location.origin) return;
    campaignKeys.forEach(function (key) { if (campaign[key]) target.searchParams.set(key, campaign[key]); });
    link.href = target.pathname + target.search + target.hash;
  });

  function vegasToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return values.year + '-' + values.month + '-' + values.day;
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  document.querySelectorAll('input[type="date"]').forEach(function (input) {
    if (!input.min || input.closest('.product-form')) input.min = vegasToday();
  });

  document.querySelectorAll('input[type="date"][data-allowed-days]').forEach(function (input) {
    var allowedDays = input.getAttribute('data-allowed-days').split(',').map(Number);
    var error = input.parentElement.querySelector('[data-date-error]');
    var form = input.closest('form');

    function validateDate() {
      if (!input.value) {
        input.setCustomValidity('');
        if (error) error.hidden = true;
        return true;
      }
      var parts = input.value.split('-').map(Number);
      var chosen = new Date(parts[0], parts[1] - 1, parts[2]);
      var valid = allowedDays.indexOf(chosen.getDay()) !== -1;
      if (valid) {
        input.setCustomValidity('');
        if (error) error.hidden = true;
        return true;
      }
      var message = allowedDays.length === 1 && allowedDays[0] === 6
        ? 'Choose a Saturday.'
        : allowedDays.length === 1 && allowedDays[0] === 0
          ? 'Choose a Sunday.'
          : 'Choose a Monday through Friday date.';
      input.setCustomValidity(message);
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
      return false;
    }

    input.addEventListener('change', validateDate);
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!validateDate()) {
          event.preventDefault();
          input.reportValidity();
          input.focus();
        }
      });
    }
  });

  var params = pageParams;
  if (params.get('interest') === '30-day-private') {
    var topic = document.querySelector('[data-contact-topic]');
    var subject = document.querySelector('[data-contact-subject]');
    if (topic) topic.value = '30-Day Private access';
    if (subject) subject.value = '30-Day Private Access Request';
  }
  if (params.get('interest') === 'record-documentation') {
    var recordTopic = document.querySelector('[data-contact-topic]');
    var recordSubject = document.querySelector('[data-contact-subject]');
    if (recordTopic) recordTopic.value = 'Record documentation';
    if (recordSubject) recordSubject.value = 'Vegas Kings Record Documentation Request';
  }

  var campaignSourceField = document.querySelector('[data-contact-campaign-source]');
  var campaignNameField = document.querySelector('[data-contact-campaign-name]');
  if (campaignSourceField) campaignSourceField.value = campaign.utm_source || '';
  if (campaignNameField) campaignNameField.value = campaign.utm_campaign || '';

  var success = document.querySelector('[data-form-success]');
  if (success) {
    publish('monthly_inquiry_succeeded', Object.assign({ form: 'contact' }, campaignPayload()));
    success.focus();
  }
})();
